(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/match-init-box-light/assets/javascripts/match-init-box.js') >= 0) return;  svs.modules.push('/components/sport/match-init-box-light/assets/javascripts/match-init-box.js'); 
'use strict';

var svs = svs || {};

(function(svs) {
  var isServer = typeof exports === 'object';

  svs.sport = svs.sport || {};

  svs.sport.MatchInitBoxLight = function MatchInitBox() {
    function createInit(draw) {
      var sport = _sportIfCoverage(draw.match, isLive, draw.sport),
        matchLiveOrEnded = _isMatchLiveOrEnded(sport, draw.match),
        isLive = isDrawLive(draw.match, draw.regCloseTime);
      return _createInitBoxObject({
        match: draw.match,
        closeTime: !(isLive || matchLiveOrEnded),
        regCloseTime: draw.regCloseTime,
        isLive:
          isLive ||
          draw.hasLiveDraw ||
          draw.categoryId === 2 ,
        sport: sport,
        date: true,
        liveDraw: isLive,
        media: draw.media,
        hideMatchInfo: !(isLive || matchLiveOrEnded),
        showStartText: false
      });
    }

    function isDrawLive(match, regCloseTime) {
      return (
        Date.parse(regCloseTime) &&
        new Date(regCloseTime).getTime() < Date.now() &&
        (!match || match.statusId > 0)
      );
    }

    function _sportIfCoverage(match, isLive, sport) {
      if (match && match.coverage === 0 && isLive) {
        return { id: 0 };
      }
      return sport;
    }

    function getThemeLoader() {
      var themeLoader;
      if (!isServer) {
        themeLoader = svs.sport.themeLoader;
      } else {
        var trinidad = require('trinidad-core').core;
        themeLoader = trinidad.components.require('sport', 'theme').api;
      }

      return themeLoader;
    }

    function _isMatchLiveOrEnded(sport, match) {
      var sportId = sport && sport.id,
        statusId = match && match.statusId,
        themeLoader = getThemeLoader(),
        theme,
        isEnded,
        isLive;

      if (statusId === undefined || !sportId) {
        return;
      }

      theme = new themeLoader({ sport: sportId });

      theme.load(function(template, init) {
        if (init) {
          isLive = init('isLive', statusId);
          isEnded = init('isEnded', statusId);
        }
      }, 'init');

      return isLive || isEnded;
    }

    function _createInitBoxObject(options) {
      var initBoxObject = {},
        sportId = true,
        showDate = options.date,
        closeTime;
      if (showDate === undefined) {
        showDate = true;
      }
      if (options.liveDraw) {
        showDate = false;
      }
      if (options.closeTime) {
        closeTime = options.regCloseTime;
      } else {
        closeTime = false;
      }

      if (options.sport) {
        sportId = options.sport.id;
      }

      if (!options.match) {
        initBoxObject = {
          opt: {
            tv: options.media, 
            live: options.isLive, 
            spelstopp: closeTime, 
            date: false,
            startedLiveDraw: options.liveDraw
          },
          startTime: false,
          status: false, 
          matchId: false,
          sport: sportId,
          hideMatchInfo: options.hideMatchInfo,
          showStartText: options.showStartText
        };
      } else {
        initBoxObject = {
          opt: {
            tv: options.media, 
            live: options.isLive, 
            spelstopp: closeTime, 
            date: showDate,
            startedLiveDraw: options.liveDraw
          },
          startTime: options.match.matchStart,
          status: {
            id: options.match.statusId,
            realTime: options.match.statusTime
          }, 
          matchId: options.match.matchId,
          sport: sportId,
          hideMatchInfo: options.hideMatchInfo,
          showStartText: options.showStartText
        };
      }

      return initBoxObject;
    }

    return {
      createInit: createInit,
      getThemeLoader: getThemeLoader
    };
  };

  svs.sport.matchInitBoxLight = new svs.sport.MatchInitBoxLight();

  if (isServer) {
    module.exports = svs.sport.matchInitBoxLight;
  }
})(svs);

 })(window);